import type { SxProps, Theme } from "@mui/material/styles";
import {
  HEADER_HEIGHT,
  MAX_WIDTH,
  SIDE_PADDING,
  TOP_PADDING,
} from "../../theme/consts";

export const rootSx: SxProps<Theme> = {
  minHeight: "100svh",
  display: "flex",
  flexDirection: "column",
};

export const generalSectionSx: SxProps<Theme> = {
  maxWidth: MAX_WIDTH,
  width: "100%",
  margin: "0 auto",
  padding: {
    xs: `${TOP_PADDING} ${SIDE_PADDING.xs} 2rem`,
    md: `${TOP_PADDING} ${SIDE_PADDING.md} 2rem`,
    xl: `7rem ${SIDE_PADDING.xl} 2rem`,
    "2xl": `8rem ${SIDE_PADDING.xl} 6rem`,
  },
  flex: 1,
};
